<template>
    <div id="edicaoLotesLicitacao">
        <header-sagres titulo="Lotes do Processo Licitatório" :botoes="botoesHeader" />
        <b-row>
            <div class="w-100 d-flex justify-content-end">
                <busca-tabela @busca="buscarTexto" />
            </div>
            <b-table :fields="fields" :items="lotes" :busy="tableBusy" :current-page="currentPage" hover no-border-collapse
                sort-by="" stacked="sm" responsive show-empty>
                <template #empty>
                    <span>Não foram encontrados dados com estes filtros.</span>
                </template>
                <template #emptyfiltered>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #table-busy>
                    <div class="text-center text-dark">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="loading-text">Carregando...</strong>
                    </div>
                </template>
                <template #cell(NuSequencialLote)="data">
                    <b-form-input v-if="data.item.modoEdicao" :disabled="data.item.loading"
                        v-model="data.item.novoNuSequencialLote" @blur="verificarDescricao(data.item)"></b-form-input>
                    <span v-else>{{ data.value }}</span>
                </template>
                <template #cell(DeLote)="data">
                    <b-form-input v-if="data.item.modoEdicao" :disabled="data.item.loading" v-model="data.item.novaDeLote"
                        maxlength="100"></b-form-input>
                    <span v-else>{{ data.value }}</span>
                </template>
                <template v-slot:cell(detalhes)="row">
                    <b-link class="text-dark" @click="row.toggleDetails">
                        <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
                    </b-link>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-overlay :show="row.item.loading" variant="transparent" opacity="0.8" blur="1px">
                        <div v-if="row.item.modoEdicao" class="actions-icons">
                            <b-link class="text-dark" @click="salvarEdicaoLote(row.item)">
                                <font-awesome-icon icon="save" />
                                <div style="font-size: 12px">Salvar</div>
                            </b-link>
                            <b-link class="text-dark" @click="pararEdicaoLote(row.item)">
                                <font-awesome-icon icon="cancel" />
                                <div style="font-size: 12px">Cancelar {{ row.item.IdLoteLicitacao ? 'edição' : '' }}</div>
                            </b-link>
                        </div>
                        <div v-else class="actions-icons">
                            <b-link class="text-dark" @click="editarLoteLicitacao(row.item)">
                                <font-awesome-icon icon="edit" />
                                <div style="font-size: 12px">Editar lote</div>
                            </b-link>
                            <btn-excluir :idItem="row.item" :excluirItem="removerLoteLicitacao" />
                        </div>
                    </b-overlay>
                </template>
                <template #row-details="row">
                    <editar-itens-lote-licitacao :idLote="row.item.IdLoteLicitacao"
                        @loteAtualizado="atualizarLoteNaTabela(row.item)"></editar-itens-lote-licitacao>
                </template>
                <template #custom-foot>
                <b-tr v-if="licitacaoVlTotalEstimado" class="font-weight-bold">
                    <b-td colspan="4" class="text-right"></b-td>
                    <b-td class="text-right">
                        {{ licitacaoVlTotalEstimado ? formatMoeda(licitacaoVlTotalEstimado) : '' }}
                    </b-td>
                    <b-td></b-td>
                </b-tr>
            </template>
            </b-table>
            <table-pagination v-if="totalRows > pageSize" :total-rows="totalRows" :per-page="pageSize"
                :firstCurrentPg="currentPage" @pageChange="pageChange" />
        </b-row>
        <modal-importar-itens-licitacao v-if="exibirModalImportacao" @fecharModal="onFecharModalImportacao"
            :idLicitacao="lic.IdLicitacao" modo="lote" />
    </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue"
import HeaderSagres from '@/components/shared/HeaderSagres.vue'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import { eventBus } from '@/main'
import ldiService from '@/services/licitacoes/ldiService'
import { store } from "@/store"
import { BotaoSagres } from '@/types/botao-sagres'
import { acoesEdicaoLote, detalhes, fieldsLoteLicitacao } from '@/types/licitacoes/ldi/fields-lote-licitacao'
import { LoteLicitacao } from '@/types/licitacoes/ldi/lote-licitacao'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { ValidationObserver } from 'vee-validate'
import { mixins } from 'vue-class-component'
import { Component, Ref, Vue } from 'vue-property-decorator'
import EditarItensLoteLicitacao from '../EditarItensLoteLicitacao.vue'
import ModalImportarItensLicitacao from '../ModalImportarItensLicitacao.vue'
import BuscaTabela from '@/components/shared/BuscaTabela.vue'

const CompProps = Vue.extend({
    name: 'AbaEditarLotes',
    components: { BtnExcluir, BuscaTabela, EditarItensLoteLicitacao, HeaderSagres, ModalImportarItensLicitacao, TablePagination },
    props: {
        lic: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class AbaEditarLotes extends mixins(UtilsTS, CompProps) {
    @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>

    //manipulação de lotes
    novoLote: LoteLicitacao = new LoteLicitacao()
    editLote = false //true para modo edição, false para ocultar os campos de adição

    //table-related
    fields: TableField[] = [detalhes, ...fieldsLoteLicitacao, acoesEdicaoLote]
    lotes: LoteLicitacao[] = []
    botoesHeader: BotaoSagres[] = [
        {
            id: 1,
            icone: 'plus',
            texto: 'Adicionar Lote',
            acao: this.criarNovoLote,
        },
        {
            id: 2,
            icone: 'cloud-upload',
            texto: 'Importar Itens',
            acao: this.abrirModalImportacao
        }
    ]
    currentPage = 1
    pageSize = 5
    totalRows = 0
    tableBusy = false
    filtroTexto = ''
    licitacaoVlTotalEstimado: number | null = null

    //modal de importação
    exibirModalImportacao = false

    existeEdicao(): boolean {
        return this.lotes?.some(lo => lo.modoEdicao)
    }

    abrirModalImportacao(): void {
        this.exibirModalImportacao = true
    }

    mounted(): void {
        //this.novoLote.IdLicitacao = this.lic.IdLicitacao
        this.loadData()
    }

    buscarTexto(novoFiltro: string): void {
        this.filtroTexto = novoFiltro
        this.loadData()
    }

    async loadData(adicionarUmaLinha = false): Promise<void> {
        try {
            this.tableBusy = true
            this.totalRows = 0
            this.licitacaoVlTotalEstimado = null
            const response = await ldiService.buscarLotes(this.lic.IdLicitacao, this.currentPage, this.pageSize, this.filtroTexto)
            if (response) {
                this.lotes = response.lotes.map(l => {
                    const lote = Object.assign(new LoteLicitacao(), l)
                    return lote
                })
                this.totalRows = adicionarUmaLinha ? response.totalRows + 1 : response.totalRows
                this.licitacaoVlTotalEstimado = response.licitacaoVlTotalEstimado
            } else {
                this.$toast.error('Erro ao consultar os lotes desta licitação.');
            }
        } finally {
            this.tableBusy = false;
        }
    }
    async pageChange(value: number, adicionarUmaLinha = false): Promise<void> {
        this.currentPage = value;
        await this.loadData(adicionarUmaLinha);
    }
    editarLoteLicitacao(value: LoteLicitacao): void {
        if (this.existeEdicao()) return;
        this.fecharTodasRows()
        const meuLote = this.lotes.find(lo => lo.IdLoteLicitacao === value.IdLoteLicitacao)
        if (meuLote) {
            meuLote.modoEdicao = true
            meuLote._rowVariant = 'active'
            meuLote.novaDeLote = meuLote.novaDeLote || meuLote.DeLote
            meuLote.novoNuSequencialLote = meuLote.novoNuSequencialLote || meuLote.NuSequencialLote
        }
    }
    pararEdicaoLote(lote: LoteLicitacao): void {
        if (lote.IdLoteLicitacao) {
            const meuLote = this.lotes.find(lo => lo.IdLoteLicitacao === lote.IdLoteLicitacao)
            if (meuLote) {
                meuLote.modoEdicao = false
                meuLote._rowVariant = ''
            }
        } else {
            this.lotes = this.lotes.filter(l => l.IdLoteLicitacao !== undefined)
            this.recalcularTabela('sub')
        }
    }
    async salvarEdicaoLote(lote: LoteLicitacao) {
        const meuLote = this.lotes.find(lo => lo.IdLoteLicitacao === lote.IdLoteLicitacao)
        try {
            if (meuLote) {
                meuLote.loading = true
                if (!this.isNumeric(meuLote.novoNuSequencialLote)) return this.$toast.error('O número sequencial do lote deve ser um número inteiro.')
                const retorno = await ldiService.adicionarLoteLicitacao(lote)
                const isAdicao = meuLote.modoEdicao && meuLote.IdLoteLicitacao === undefined
                this.atualizarLoteNaTabela(retorno, false, isAdicao)
                this.$toast.success(`O lote ${retorno.DeLote} foi ${meuLote.IdLoteLicitacao ? 'atualizado' : 'salvo'}.`)
            }
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            if (meuLote) meuLote.loading = false
        }
    }
    async removerLoteLicitacao(lote: LoteLicitacao) {
        try {
            store.blockScreen = true
            const retorno = await ldiService.removerLoteLicitacao(lote.IdLoteLicitacao)
            if (retorno) {
                this.lotes = this.lotes.filter(p => p.IdLoteLicitacao !== lote.IdLoteLicitacao)
                if (this.lotes.length < 1) {
                    await this.pageChange(this.currentPage > 1 ? this.currentPage - 1 : this.currentPage)
                } else {
                    this.totalRows--
                    this.$emit('input', this.lotes);
                }
                this.$toast.success(`O lote ${lote.DeLote} foi removido desta licitação.`)
                eventBus.$emit('atualizar-status-licitacao')
            }
            else this.$toast.error(`Falha ao remover o lote ${lote.DeLote}.`)
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            store.blockScreen = false
        }
    }
    fecharTodasRows(): void {
        this.lotes.forEach(ll => ll._showDetails = false)
        this.$emit('input', this.lotes);
    }
    /**
     * Limpa a tela e abre o formulário de novo lote
     */
    async criarNovoLote(): Promise<void> {
        if (this.existeEdicao()) return;
        //ir para última página
        await this.recalcularTabela()

        //criar lote vazio, colocar no final do array
        const novoLote = new LoteLicitacao()
        novoLote.modoEdicao = true
        novoLote._rowVariant = 'active'
        novoLote.IdLicitacao = this.lic.IdLicitacao
        novoLote.NuSequencialLote = this.totalRows + 1
        //tá faltando colocar o sequencialote aqui
        this.lotes.push(novoLote)
        this.$emit('input', this.lotes);
    }
    /** 
     * Cuido de mudar a página da tabela do usuário sempre que for preciso, ex.: Usuário tem 5 lotes e adiciona 1, ou usuário tem 6 lotes e remove 1.
     * @since 20230615
     */
    async recalcularTabela(operacao = 'add'): Promise<void> {
        if (operacao === 'add') {
            if (this.totalRows % this.pageSize === 0) {
                const novaPagina = Math.floor(this.totalRows / this.pageSize) + 1
                await this.pageChange(novaPagina, true)
            } else {
                this.totalRows++
            }
        }
        if (operacao === 'sub') {
            if ((this.totalRows - 1) % this.pageSize === 0) {
                await this.pageChange(this.currentPage - 1)
            } else {
                this.$emit('input', this.lotes);
            }
        }
    }
    /** Busca um lote na API e o substitui na tabela pela versão mais nova.
     * @param lote O lote a ser atualizado
     * @param buscarNaAPI false caso queira apenas trocar pela instância recebida
     * @since 20230616
     */
    async atualizarLoteNaTabela(lote: LoteLicitacao, buscarNaAPI = true, isAdicao = false): Promise<void> {
        const meuLote = this.lotes.find(l => l.IdLoteLicitacao === (isAdicao ? undefined : lote.IdLoteLicitacao))
        if (meuLote) {
            try {
                meuLote.loading = true
                const index = this.lotes.indexOf(meuLote)
                if (buscarNaAPI)
                    lote = await ldiService.buscarLotePorId(lote.IdLoteLicitacao)
                meuLote.loading = false
                this.lotes.splice(index, 1, lote)
                this.$emit('input', this.lotes);
                eventBus.$emit('atualizar-status-licitacao')
            } catch (e: any) {
                this.tratarError(e)
            }
        }
    }

    onFecharModalImportacao(refresh = false): void {
        this.exibirModalImportacao = false
        if (refresh) this.loadData()
    }

    verificarDescricao(novoLote: LoteLicitacao): void {
        if (novoLote.novoNuSequencialLote && (!novoLote.novaDeLote || novoLote.novaDeLote.trim() === '')) {
            novoLote.novaDeLote = `Lote ${novoLote.novoNuSequencialLote}`
            this.atualizarLoteNaTabela(novoLote, false)
        }
    }
}

</script>